// extracted by mini-css-extract-plugin
module.exports = {"carousel-wrapper":"Carousel_carousel-wrapper__mLDPb","carousel-image":"Carousel_carousel-image__lMfvv","carousel":"Carousel_carousel__J1t7W"};